import React__default from 'react';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';
import { useStyles } from '@sravni/react-utils';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import { decorateRelativeUrlByDomain, makeRelAttribute } from '../../../utils/links.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import modules_a4a8ece5 from '../styles/DesktopMenuTopLink.module.less.js';

const DesktopMenuTopLink = React__default.forwardRef((props, ref) => {
    const { className, item, children, ...restProps } = props;
    const { isLink, text, href, openInNew } = item;
    const { domains } = useCustomProps();
    const cx = useStyles(modules_a4a8ece5);
    const { pushAnalyticEvent } = useAnalyticEvents();
    const handleLinkClick = React__default.useCallback((event) => {
        const label = event.currentTarget.dataset.label || '';
        pushAnalyticEvent("menuLinkClick" /* EVENTS.MENU_LINK_CLICK */, { eventLabel: `${label}|Переход по разделу` });
    }, [pushAnalyticEvent]);
    return (React__default.createElement("div", { className: cx(className, 'itemWrapper'), ...restProps, ref: ref },
        isLink && href ? (React__default.createElement(Link, { "data-label": text, color: "black", href: domains?.base ? decorateRelativeUrlByDomain(href, domains.base) : href, target: openInNew ? '_blank' : undefined, rel: makeRelAttribute(item), onClick: handleLinkClick, className: cx('item') },
            React__default.createElement(Text, { strong: true }, text))) : (React__default.createElement(Text, { "data-label": text, className: cx('item'), strong: true }, text)),
        children));
});
DesktopMenuTopLink.displayName = 'DesktopMenuTopLink';

export { DesktopMenuTopLink };
//# sourceMappingURL=DesktopMenuTopLink.js.map
